import axios from 'axios'
import {config} from '../Config/config'

const lokasiService = {
    getAll : () => {
        const result = axios.get(config.apiUrl + '/lokasi')
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    getById : (id) => {
        const result = axios.get(config.apiUrl + '/lokasiById/' + id)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result[0]
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    
}


export default lokasiService